<div>
	<p class="h3">{{ 'dialogs.changeContext.title' | translate }}</p>

	<form [formGroup]="contextForm" fxLayout="column" fxLayoutGap="8px">
		@if (isCancom && !isPreselectedTenant && !userService.impersonatedCRN) {
			<mcm-customer-select formControlName="tenant" (selectionFinalized)="customerSelectionFinalized()"></mcm-customer-select>
		} @else {
			<mat-form-field>
				<mat-label>{{ 'common.tenant' | translate }}</mat-label>
				<mat-select formControlName="assumableTenant">
					@for (role of assumableRoles; track $index) {
						<mat-option [value]="role.tenant">{{ role.displayName }} | {{ role.tenant }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}

		@if (suggestedSubaccounts && subaccountsEnabled) {
			<mat-form-field>
				<mat-label>{{ 'common.subaccount' | translate }}</mat-label>
				<input matInput formControlName="subaccount" [matAutocomplete]="subaccountAutofill" />
				<mat-autocomplete #subaccountAutofill="matAutocomplete" [displayWith]="renderOption">
					<mat-option [value]="accountService.defaultSubaccount">{{ accountService.defaultSubaccount.displayName }}</mat-option>
					@for (subaccount of suggestedSubaccounts; track $index) {
						<mat-option [value]="subaccount"> {{ subaccount.displayName }} | {{ subaccount.subAccount }} </mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
		}

		<div fxLayout="row" fxLayoutGap="12px">
			<mat-form-field>
				<mat-label>{{ 'dialogs.changeContext.roleType' | translate }}</mat-label>
				<mat-select [(value)]="roleType" (selectionChange)="changeRoleType($event.value)">
					<mat-option value="role">{{ 'iam.principalTypes.role.singular' | translate }}</mat-option>
					<mat-option value="managed-role">{{ 'iam.principalTypes.managedRole.singular' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field style="width: 100%">
				<mat-label>{{ 'dialogs.changeContext.roleName' | translate }}</mat-label>
				<input matInput formControlName="role" [matAutocomplete]="roleAutofill" />
				<mat-autocomplete #roleAutofill="matAutocomplete">
					@for (role of suggestedRoles; track $index) {
						<mat-option [value]="role">{{ role }}</mat-option>
					}
				</mat-autocomplete>
				@if (suggestedRoles.length === 0) {
					<mat-hint>{{ 'dialogs.changeContext.noRoleSuggestions' | translate }}</mat-hint>
				}
			</mat-form-field>
		</div>

		<button mat-raised-button color="primary" type="submit" (click)="changeContext()" [disabled]="!contextForm.valid">
			{{ 'dialogs.changeContext.switchContext' | translate }}
		</button>
	</form>
</div>
